import { render } from "./personFiscalData.vue?vue&type=template&id=6c2bf891&ts=true"
import script from "./personFiscalData.vue?vue&type=script&lang=ts"
export * from "./personFiscalData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__